/**
 * Whether the session countdown chip is shown in the dashboard top bar (localStorage, default on).
 */
export const SESSION_TIMER_BAR_VISIBLE_KEY = 'sessionTimerBarVisible';
export const SESSION_TIMER_BAR_VISIBLE_EVENT = 'sessionTimerBarVisibilityChanged';

/** Default on so the top-bar countdown is visible without visiting Session Alert settings. */
export const SESSION_TIMER_BAR_VISIBLE_DEFAULT = true;
const DEFAULT_VISIBLE = SESSION_TIMER_BAR_VISIBLE_DEFAULT;

export function getSessionTimerBarVisible() {
  try {
    const raw = localStorage.getItem(SESSION_TIMER_BAR_VISIBLE_KEY);
    if (raw === null || raw === '') return DEFAULT_VISIBLE;
    return raw === '1' || raw === 'true';
  } catch {
    return DEFAULT_VISIBLE;
  }
}

export function setSessionTimerBarVisible(visible) {
  const v = !!visible;
  try {
    localStorage.setItem(SESSION_TIMER_BAR_VISIBLE_KEY, v ? '1' : '0');
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent(SESSION_TIMER_BAR_VISIBLE_EVENT, { detail: { visible: v } })
  );
  return v;
}
